import { apiClient } from "@apis/apiClient";
import type { ApiResponse, RecentEntityType, RecentItem } from "./recentsClient.dto";

const recentsClient = {
  /**
   * Record access to an entity (creates or updates timestamp)
   */
  recordAccess(entityType: RecentEntityType, entityId: number | string): Promise<ApiResponse<RecentItem>> {
    return apiClient.post(`/rest/recents/${entityType}/${entityId}`);
  },

  /**
   * Get recent entity IDs for a specific type
   * @param limit Maximum number of results (default 10)
   */
  getRecentEntityIds(entityType: RecentEntityType, limit = 10): Promise<ApiResponse<number[]>> {
    return apiClient.get(`/rest/recents/${entityType}?limit=${limit}`);
  },

  /**
   * Remove a specific entity from recents
   */
  removeRecent(entityType: RecentEntityType, entityId: number | string): Promise<ApiResponse<boolean>> {
    return apiClient.delete(`/rest/recents/${entityType}/${entityId}`);
  },

  /**
   * Clear all recent entries for a specific entity type
   * Returns the number of entries cleared
   */
  clearRecents(entityType: RecentEntityType): Promise<ApiResponse<number>> {
    return apiClient.delete(`/rest/recents/${entityType}`);
  },
};

export { recentsClient };
export default recentsClient;
